/* eslint-disable react/prop-types */
import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import TitleBasic, {titleBasicColors, titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import CarfaxServiceVerifiedDataContentList from './carfax-service-verified-data-content-list.js'
import {BASE_CLASS} from './config.js'

const CardCarfaxServiceContent = ({verifiedData}) => {
  const {i18n} = useContext(Context)
  const titleLiteral = i18n.t('CARFAX.VERIFIED_DATA_PANEL_INFO.TITLE')

  return (
    <div className={`${BASE_CLASS}-serviceContent`}>
      <TitleBasic
        as={titleBasicTags.h3}
        color={titleBasicColors.gray}
        size={titleBasicSizes.xs}
        title={i18n.t(titleLiteral)}
      />
      <CarfaxServiceVerifiedDataContentList contentList={verifiedData} />
    </div>
  )
}

CardCarfaxServiceContent.displayName = 'CardCarfaxServiceContent'
CardCarfaxServiceContent.propTypes = {
  verifiedData: PropTypes.shape({
    ageInMonths: PropTypes.number,
    isChassisModified: PropTypes.bool,
    isUsedAsTaxi: PropTypes.bool,
    reportUrl: PropTypes.string,
    verifiedOdometerReadings: PropTypes.number
  })
}

export default CardCarfaxServiceContent
